export default {
	archivedText: "Goal archived by {changedBy}",
	unarchivedText: "Goal unarchived by {changedBy}",
};
